import { Fragment } from "react";

import useAccountCreationParentWarning from "./UseAccountCreationParentWarning";

import Headings from "@usas/ui-web/components/headings/Headings";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import AccountCreationReturnButton from "../../components/buttons/AccountCreationReturnButton";

import style from '../../../../LandingPages.module.css';

const AccountCreationParentWarning = () => {
  const {
    onContinueClicked,
  } = useAccountCreationParentWarning();

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-md-2" />
        <div className={['col-xs-12', 'col-md-8'].join(' ')}>
          <div className={["row", style.CenterPageContent].join(' ')}>
            <Headings.H3>Before Creating an Account</Headings.H3>
          </div>
          <div style={{ padding: '1em', borderRadius: '4px' }} className={["usas-extra-top-margin usas-extra-bottom-margin", 'very-light-gray'].join(' ')}>
            <p>
              <strong>Please review the following before creating an account. </strong>
            </p>

            <p>Here&#39;s what you need to know:</p>

            <ul style={{ listStylePosition: 'outside', paddingLeft: '.9em' }}>
              <li>You are creating a USA Swimming Login Account - not a membership.</li>
              <li>All child accounts must be approved by a parent for safety and compliance.</li>
            </ul>
            <br />
            <p>
              <strong>If you are under the required age, you will have to provide a phone number of a parent or guardian for verification.</strong>
            </p>
          </div>

          <div className={["row", style.CenterPageContent].join(' ')}>
            <div className="col-xs-12 usas-extra-top-margin">
              <PrimaryButton onClick={onContinueClicked}>
                I Understand, Continue
              </PrimaryButton>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <AccountCreationReturnButton buttonLabelPrefix="Cancel & Return To" />
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-2" />
      </div>
    </Fragment>
  );
};

export default AccountCreationParentWarning;